import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { UserService } from '../../features/user-administration/services';
import { User } from '../../features/user-administration/models';
import * as UserActions from './user.actions';

export const loadUsers$: ReturnType<typeof createEffect> = createEffect(
  (actions$ = inject(Actions), userService = inject(UserService)) => {
    return actions$.pipe(
      ofType(UserActions.loadUsers),
      switchMap(() =>
        userService.getAllUsers().pipe(
          map((users: User[]) => UserActions.loadUsersSuccess({ users })),
          catchError(error =>
            of(
              UserActions.loadUsersFailure({
                error: error.message ?? 'Unknown error loading users',
              })
            )
          )
        )
      )
    );
  },
  { functional: true }
);

export const userEffects: object = { loadUsers$ };
